import Vue from 'vue'
import {ProjectStatuses} from '../config/enum/ProjectStatuses'

Vue.filter('projectStatus', function(value) {
    let projectStatus = ProjectStatuses.find((el)=>el.value === value)
    return projectStatus ? projectStatus.label : '';
});



// WEBPACK FOOTER //
// ./src/filters/projectStatus.js